import styled from 'styled-components';
import { Text } from '@spotify-internal/encore-web';

const Ellipsis = styled(Text)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export default Ellipsis;
